var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import injectReducer from '@project/utils/injectReducer';
import { compose } from 'redux';
import reducer from './reducer';
import { Helmet } from 'react-helmet';
import { makeSelectUser } from '../Root/selectors';
import * as pageSelectors from './selectors';
import * as actions from './actions';
import { LoadingSpinner } from '../../components/base';
import { P } from '../../components/UI-helpers/typography';
import { Button } from '@appspotr/ui-kit';
import toast from '../../components/Toast';
import ConfirmationPopUp from '../../components/PopUp/ConfirmationPopUp';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import { PageWrapper, PageHeader, PageContent, PageHeaderTitle, } from '../../components/Page';
import { RequestTitle, RequestButton, BackContainer, BackContainerBox, DataPrivacyWrapper, RequestWrapper, RequestTitleBox, RequestTitleWrapper, } from './styles';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
var RequestData = /** @class */ (function (_super) {
    __extends(RequestData, _super);
    function RequestData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisiblePopUp: false,
        };
        _this.UIActions = {
            popup: {
                show: function () {
                    _this.setState({ isVisiblePopUp: true });
                },
                hide: function () {
                    _this.setState({ isVisiblePopUp: false });
                },
            },
        };
        return _this;
    }
    RequestData.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.dataAndPrivacy.loading &&
            !this.props.dataAndPrivacy.loading) {
            if (this.props.dataAndPrivacy.error !== '') {
                toast.error(this.props.dataAndPrivacy.error);
            }
            else {
                toast.success('Information fetched!');
            }
        }
    };
    RequestData.prototype.render = function () {
        var _this = this;
        var loading = this.props.dataAndPrivacy.loading;
        var crumbs = [
            { to: '/dataprivacy', text: 'Data & Privacy' },
            { to: '/dataprivacy/requestdata', text: 'Request Data' },
        ];
        return (_jsxs(PageWrapper, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Information & Data Request" }), _jsx("meta", { name: "description", content: "Information & Data Request" })] }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsx(RequestWrapper, { children: _jsx(BackContainer, { children: _jsx(BackContainerBox, { children: _jsx(Button, __assign({ type: "outline", onClick: function () { return _this.props.navigate(-1); }, iconLeft: faChevronLeft }, { children: "Back" })) }) }) }), _jsx(PageContent, { children: _jsxs(DataPrivacyWrapper, { children: [_jsx(ConfirmationPopUp, { isVisible: this.state.isVisiblePopUp, onHide: this.UIActions.popup.hide, title: "Are you sure that you want to send the data request ?", onConfirmation: function () {
                                    _this.props.sendDataRequest();
                                } }), _jsx(RequestTitle, { children: _jsx(P, __assign({ black: true, bold: true, fontSize: 24 }, { children: "Information & Data Request" })) }), _jsx(RequestTitleWrapper, { children: _jsxs(RequestTitleBox, { children: [_jsx(P, __assign({ black: true }, { children: "We will email you a link to a file with your information and data. It may take up" })), _jsx(P, __assign({ black: true }, { children: "to 48 hours to collect this data and send it to you." }))] }) }), _jsx(RequestButton, { children: loading ? (_jsx(LoadingSpinner, {})) : (_jsx(Button, __assign({ style: { width: 200, justifyContent: 'center' }, type: "primary", onClick: this.UIActions.popup.show }, { children: "Request" }))) })] }) })] }));
    };
    return RequestData;
}(React.Component));
var mapStateToProps = createStructuredSelector({
    user: makeSelectUser(),
    dataAndPrivacy: pageSelectors.makeDataAndPrivacyPageDomain(),
});
var mapDispatchToProps = function (dispatch) { return ({
    sendDataRequest: function () {
        dispatch(actions.sendDataRequest());
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
var withReducer = injectReducer({
    key: 'dataAndPrivacy',
    reducer: reducer,
});
var RequestDataPageWrapper = function (props) {
    var params = useParams();
    var navigate = useNavigate();
    return (_jsx(ConnectedRequestDataPage, __assign({ params: params, navigate: navigate }, props)));
};
var ConnectedRequestDataPage = compose(withConnect, withReducer)(RequestData);
export default RequestDataPageWrapper;
